export default {
    init: function () {
        document.querySelectorAll(".search_link").forEach(function (el) {
            el.href = `${window.location}#searchModal`;
        });
        document.querySelector(
            ".light-modal-close-icon"
        ).href = `${window.location}#/`;
    }
};
